<div class="widget" (click)="onClick()">
  <div class="round-button">Поддержка в боте Telegram</div>
  <div class="telegram"></div>
</div>
